<h4>{{title}}</h4>

<section>
  <form class="cell" [formGroup]="form">
    <div class="grid-x">
      <div class="auto cell">
        <label>Note Type:</label>
        <select name="type" formControlName="selectedNoteType" required>
          <option value="-1" disabled>Select note type</option>
          @for (t of types; track t) {
            <option [value]="noteType[t]">{{t}}</option>
          }
        </select>
        @if (form.get('selectedNoteType'); as noteType) {
          <div class="error-container">
            @if (noteType.errors) {
              <small class="error">Note type is required</small>
            }
          </div>
        }
      </div>
    </div>

    <div class="margin-top outline-container">
      <label>Text:</label>
      <div formControlName="noteText" name="text" [froalaEditor]="froalaOptions"></div>
    </div>

    <div class="text-align-center margin-top">
      <button class="button hollow" (click)="cancel()">Cancel</button>
      <button class="button" [disabled]="form.invalid" (click)="save()">Save</button>
    </div>
  </form>

  <hr>

    @if (contactNotes) {
      <section class="cell notes">
        @for (note of contactNotes; track note; let i = $index) {
          <div class="padding-all margin-top margin-bottom"
            [ngClass]="{ 'private-note': note.type < 2, 'public-note': note.type === 2 }">
            <div #replyForm>
              <div class="note-group">
                @if (note.notes.length) {
                  <div class="expander float-left" [ngClass]="{ 'opened': replyForm.opened }"
                  (click)="replyForm.opened = !replyForm.opened"></div>
                }
                <div class="notes no-margin">
                  <div class="note-header default-font">
                    <strong>{{note.createdBy}}</strong><span class="float-right">{{ note.createdDate | date: 'M/d/yy | h:mma' }}</span></div>
                    <div [innerHTML]="note.text"></div>
                    @if (note.files.length) {
                      <hr />
                    }
                    @for (file of note.files; track file) {
                      <div>
                        <a [href]="file.path">{{file.fileName}}</a>
                      </div>
                    }
                    <div class="childNotes" [ngClass]="{ 'opened': replyForm.opened }">
                      @for (childNote of note.notes; track childNote) {
                        <div>
                          <div class="note-header default-font"><strong>{{childNote.createdBy}}</strong><span
                        class="float-right">{{childNote.createdDate | date: 'M/d/yy | h:mma'}}</span></div>
                        <div [innerHTML]="childNote.text"></div>
                        @if (childNote.files.length) {
                          <hr />
                        }
                        @for (file of childNote.files; track file) {
                          <div>
                            <a [href]="file.path">{{file.fileName}}</a>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              @if (!replyForm.isReplying) {
                <div class="text-align-right">
                  <button (click)="openReplyForm(replyForm)" attr.aria-label="Open reply form" title="Open reply form">
                    <svg-icon icon="icon-reply" aria-hidden="true"></svg-icon>
                  </button>
                </div>
              }
              @if (replyForm.isReplying) {
                <div>
                  <div name="text" [(froalaModel)]="replyForm.replyText" [froalaEditor]="froalaOptions"></div>
                  @if (replyForm.isDirty && !replyForm.replyText) {
                    <div class="error-container">
                      <small class="error">Reply text is required</small>
                    </div>
                  }
                  <div class="text-align-center margin-top">
                    <button class="button hollow white-background" (click)="resetReplyForm(replyForm)">Cancel</button>
                    <button class="button" (click)="reply(note, replyForm)" [disabled]="!replyForm.replyText">Add
                    Note</button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </section>
    }
  </section>
